<template>
  <v-app>
    <v-container fluid ma-0 pa-0>
      <v-container>
        <v-row>
          <v-col>
            <span class="display-3">ePyydys</span>v 1.0 pilot  
            
            <v-btn class="right" color="blue lighten-2" dark @click="dialog=!dialog">
          ohje
        </v-btn>
          </v-col>
        </v-row>

    <v-dialog
      v-model="dialog"
      width="90%"
    >
      <v-card>
        <v-card-title dark color="blue lighten-2">
          Tervetuloa tutustumaan rysän suunnitteluun!
        </v-card-title>

        <v-card-text><br>

          <h2>Yleistä</h2>

          Projektin tavoitteena on testata nykyaikaisen tekniikan tuomista apuvälineeksi ammattikalastajien rysien (ja jatkossa mahdollisesti myös muiden pyydysten) suunniteluun. 
          <br>
          Ohjelmisto on toteutettu yhteistyössä Suomen Sisävesiammattikalastajat ry, Suomen Ammattikalastajaliitto ry ja Itä-Suomen kalatalousryhmä kanssa. <br><br>

          <h2>Ohjelman käyttö</h2>
          <li>Avaa välilehti esim. "etupesä" ja kokeile muuttaa mittoja</li>
          <li>Ohjelma laskee uusien mittojen perusteella puuttuvat mitat, päivittää 3d-kuvan ja mittakuvat.</li>
          <li>Voit vaihtaa näkymää "etuviisto", "takaviisto" - painikkeiden avulla</li>
          <li>lähennys: hiiren rulla, pyöritys: hiiren nappi + hiiren liike, siirto: hiiren molemmat napit + liike</li>


          <br><br>
          <h2>Pilot-version 1.0 muutokset, julkaistu 27.3.2021 </h2>
          <li>Havaksen silmäkoon valinta (100mm-15mm) etupesä,välipesä,kalapesä - OK</li>
          <li>Etupesän pääliverkon viistotus nielun syyvyyden mukaisesti (tasainen osa niuluun saakka ja tästä lasku suuliinalle) - OK</li>
          <li>Välipesän pituus / leveys suhde vakioksi - OK </li>
          <li>Väli- ja kalapesän nielujen kokoa säätäessä nielujen kulmat pysyvät vakioina. - OK</li>
          <li>Välipesän nielun korkeuden ja leveyden säätö (nyt vakio 0.8x0.8m) - OK</li>
          
      
          <br><br>
          <h2>Ohjelman jatkokehitysideat</h2>
          <li>Välipesän nielun kaulusverkko (nykyisestä versiosta puuttuu)</li>
          <li>Kulmien säätömahdollisuus kaikkialle</li>
          <li>Materiaali-, työaika ja hinta laskurit.</li>

<br><br>
          <h2>Pilot -version käyttö</h2>
          <li>Ohjelmaa voi käyttää vapaasti, mutta <b>muistathan että kyseessä on pilot-versio ja se voi sisältää virheitä. </b>
          <li>Annathan palautetta!</li>

<br>
          Aktivaattori, Pekka Sahama, puh 050-550 2100, pekka.sahama@kerimaki.fi<br>
          Postiosoite: Itä-Suomen kalatalousryhmä, Pekka Sahama, Pihlajavedenkuja 1 b 42, 57170 Savonlinna
        </v-card-text>

          <img src="logo3.png" style="height:150px;">
          <img src="logo2.jpg" style="height:150px;">
          <img src="lippu.jpg" style="height:150px;">

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Sulje
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

        <v-tabs v-model="tab" grow>
          <v-tab>
            <v-icon>mdi-home</v-icon>
          </v-tab>
          <v-tab v-for="(d,i) in m.groups" :key="i">{{d.name}}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item></v-tab-item>
          <v-tab-item v-for="(g,i) in m.groups" :key="i">
            <v-card outlined class="blue lighten-5">
              
              <v-card-text>
                <!--<v-sheet color="blue lighten-4">{{g.info}}</v-sheet>-->

                <v-container >
                  <v-row >
                    <span  v-for="(d,j) in m.dim" v-bind:key="j">
                      <span v-if="d.group === g.name && d.id !== 1 && d.id !== 6">
                        <v-select v-if="!m.dim[j].options"
                          @change="updateDraw()"
                          v-model="m.dim[j].value"
                          :items="opt(d)"
                          :label="d.name"
                          :suffix="d.unit"
                        ></v-select>
                        <v-select v-if="m.dim[j].options"
                          @change="updateDraw()"
                          v-model="m.dim[j].value"
                          :items="m.dim[j].options"
                          :label="d.name"
                          :suffix="d.unit"
                        ></v-select>
                      </span>
                    </span>
                    <div v-if="g.name == 'Etupesä' ">
                      <h2>Lasketut:</h2>
                      <li>pesän pituus {{ep.l}} m (määrittyy etupesän leveyden perusteella, kulma vakio)</li>
                      <li>viiston sivun pituus {{ep.l2}} m</li>
                      <li>potkun nurkan leveys noin {{ep.potku}} m</li>
                      <li>nielun pituus noin {{ep.l6}} m</li>


                      <v-alert
                        class="ma-4"
                        v-if="ep.l <= 4.5"
                        type="info"
                      >Lyhyt etupesä. Huomioi leikkaukset</v-alert>
                      
                      <v-alert
                        class="ma-4"
                        v-if="ep.potku < 1.5"
                        type="error"
                      >Kapea potku ({{ep.potku}} m), lisää kalojen silmääntymistä!
                      Säädä nielun syvyyttä.</v-alert>

  <v-alert
                        class="ma-4"
                        v-if="ep.nielu < 0.9"
                        type="error"
                      >Kapea nielu! ({{ep.nielu}} m), huomioi rajoitukset saimaan norppa-alueella: 0.9m minimileveys.</v-alert>

                      <v-alert
                        class="ma-4"
                        v-if="ep.potku > 2"
                        type="info"
                      >Leveä potku ({{ep.potku}} m)</v-alert>

                    </div>
                    <div v-if="g.name == 'Välipesä' ">
                      <h2>Lasketut:</h2>
                      <li>pituus {{vp.l}} m (määrittyy välipesän leveyden perusteella, kulma vakio)</li>
                      <li>viiston sivun pituus {{vp.l2}} m</li>
                      <li>nielun syvyys / pituus {{vp.l3}} m (määrittyy välipesän- ja nielun leveyden perusteella, kulma vakio)</li>
                    </div>
                    <div v-if="g.name == 'Kalapesä' ">
                      <h2>Lasketut:</h2>
                      <li>viiston sivun pituus {{kp.l2}} m</li>
                      <li>nielun syvyys / pituus {{kp.l3}} m (määrittyy kalapesän- ja nielun leveyden perusteella, kulma vakio)</li>
                    </div>

                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
      <v-container class="vaihto">

        <v-row>
          <v-col md="2">3D-Näkymä:</v-col>
          <v-col v-for="v in s.views" v-bind:key="v.name">
            <v-btn v-if="m.view == v" class="d-flex" :color="s.color" @click="setView(v)">{{v.name}}</v-btn>
            <v-btn v-else class="d-flex" @click="setView(v)">{{v.name}}</v-btn>
          </v-col>
          <v-checkbox v-model="s.rotate" label="Pyöritä"></v-checkbox><v-checkbox v-model="s.dark" @change="openNet()" label="Avaa"></v-checkbox>
        </v-row>
        <v-row>
          <v-col><v-icon color="blue">mdi-information</v-icon> lähennys: hiiren rulla, pyöritys: hiiren vasen nappi + hiiren liike, siirto: hiiren oikea nappi + liike
            <div id="model3d"></div>
          </v-col>
        </v-row>
      </v-container>
      <v-container>
        <v-card>
          
          <v-row class="pa-4" v-for="(d,i) in nets" :key="i">
            <v-col>
              <h2>Leikkauskuva: {{d.name}} {{d.coords.w}}</h2>
              <draw2d :coords="d.coords" :data="d" :key="2*update+i*10"></draw2d>

              <v-textarea outlined label="Ohjeet ja muistiinpanot"></v-textarea>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
      <v-container>
              <img src="logo3.png" style="height:150px;">
          <img src="logo2.jpg" style="height:150px;">
          <img src="lippu.jpg" style="height:150px;">
      </v-container>
    </v-container>
  </v-app>
</template>

<style >
.vaihto {
  page-break-after: always;
}
</style>

<script>
var _ = require("lodash");
import * as Three from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import draw2d from "./components/draw2d.vue";
//const scene = new Three.Scene();
//import * as d3 from "d3";

function rad(val) {
  return (val * Math.PI) / 180;
}

export default {
  name: "App",
  components: {
    draw2d
  },
  data() {
    return {
      update: 1,
      dialog: 0, 
      tab: "",

      ep: { l: 0, w: 0, h: 0, l2: 0, l4:0, l5:0 },
      vp: { l: 0, w: 0, h: 0, l2: 0 },
      kp: { l: 0, w: 0, h: 0, l2: 0, w2:0 },

      s: {
        dark: 0,
        rotate: 0,
        aukko: { x: 0.7, y: 0.7 },
        color: "teal lighten-4",
        step: 0.1,
        types: ["Etupesällinen rysä", "Loukku", "Katiska"],
        length: { min: 1.5, max: 5, unit: "m" },
        height: { min: 1, max: 3, unit: "m" },
        havakset: [ 100, 70, 60, 50, 40, 35, 30, 26, 20, 12],
        views: [
          { name: "Etuviisto", x: -10, y: 10, z: 10 },
          { name: "Takaviisto", x: 10, y: 10, z: 10 },
          { name: "Sivu", x: 0, y: 0, z: 10 },
          { name: "Taka", x: -10, y: 0, z: 0 },

          { name: "Ylä", x: 10, y: 0, z: 0 }
        ]
      },
      m: {
        view: "",
        groups: [
          {
            name: "Etupesä",
            info:
              "Etupesän suunnittelussa on tärkeä huomioida seuraavat asiat: ...."
          },
          {
            name: "Välipesä",
            info:
              "Välipesän suunnittelussa on tärkeä huomioida seuraavat asiat: ...."
          },
          {
            name: "Kalapesä",
            info:
              "Kalapesän suunnittelussa on tärkeä huomioida seuraavat asiat: ...."
          }
        ],
        dim: [
          {
            id: 0,
            group: "Etupesä",
            name: "Korkeus",
            value: 3,
            min: 1.5,
            max: 5,
            step: 0.1,
            unit: "m"
          },
          {
            id: 1,
            group: "Etupesä",
            name: "Pituus",
            value: 7,
            min: 3,
            max: 15,
            step: 0.1,
            unit: "m"
          },
          {
            id: 2,
            group: "Etupesä",
            name: "Leveys",
            value: 10,
            min: 6,
            max: 20,
            step: 0.5,
            unit: "m"
          },
          {
            id: 3,
            group: "Etupesä",
            name: "Nielun leveys",
            value: 1.8,
            min: 0.7,
            max: 3,
            step: 0.1,
            unit: "m"
          },
          {
            id: 4,
            group: "Etupesä",
            name: "Nielun syvyys",
            value: 2.5,
            min: 1.5,
            max: 5,
            step: 0.1,
            unit: "m"
          },
          {
            id: 5,
            group: "Välipesä",
            name: "Korkeus",
            value: 2.5,
            min: 1.5,
            max: 3.5,
            step: 0.1,
            unit: "m"
          },
          {
            id: 6,
            group: "Välipesä",
            name: "Pituus",
            value: 6,
            min: 4,
            max: 10,
            step: 0.1,
            unit: "m"
          },
          {
            id: 7,
            group: "Välipesä",
            name: "Leveys",
            value: 3,
            min: 2.5,
            max: 5,
            step: 0.1,
            unit: "m"
          },
          {
            id: 8,
            group: "Välipesä",
            name: "Nielun korkeus / leveys",
            value: 0.8,
            min: 0.4,
            max: 1,
            step: 0.1,
            unit: "m"
          },
          {
            id: 9,
            group: "Kalapesä",
            name: "Korkeus / Leveys",
            value: 1.5,
            min: 1,
            max: 2.5,
            step: 0.1,
            unit: "m"
          },
          {
            id: 10,
            group: "Kalapesä",
            name: "Pituus",
            value: 7,
            min: 4,
            max: 10,
            step: 0.1,
            unit: "m"
          },
          {
            id: 11,
            group: "Kalapesä",
            name: "Nielun korkeus / Leveys",
            value: 0.3,
            min: 0.1,
            max: 0.5,
            step: 0.05,
            unit: "m"
          },
          {
            id: 12,
            group: "Kalapesä",
            name: "Korkeus / leveys (koentasukan pääty)",
            value: 1,
            min: 0.5,
            max: 1.5,
            step: 0.1,
            unit: "m"
          },
          {
            id: 13,
            group: "Etupesä",
            name: "Havas",
            value: 50,
            options: [ 100, 70, 60, 50, 40, 35, 30, 25, 20, 12],
            unit: "mm"
          },
          {
            id: 14,
            group: "Välipesä",
            name: "Havas",
            value: 50,
            options: [ 100, 70, 60, 50, 40, 35, 30, 25, 20, 12],
            unit: "mm"
          },
          {
            id: 15,
            group: "Kalapesä",
            name: "Havas",
            value: 25,
            options: [ 100, 70, 60, 50, 40, 35, 30, 25, 20, 12],
            unit: "mm"
          }

        ],
        type: "Etupesällinen rysä",
        l: 4,
        h: 2.5,
        material: { name: "10cm x 10cm havas ", x: 0.05, y: 0.05 }
      },
      camera: null,
      scene: null,
      renderer: null,
      mesh: null,
      controls: null,
      nets: []
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      this.calcDraw();
      this.updateDraw();
    });
  },
 
     
  computed: {
    listnets() {
      return this.nets;
    }
  },
  methods: {
    openNet() {
      if(!this.s.dark) {
 
                this.scene.getObjectByName("Etupesän päällysverkko 1 kpl (viiste)").visible = true
                this.scene.getObjectByName("Etupesän päällysverkko 1 kpl (suora osa)").visible = true
                this.scene.getObjectByName("Välipesän päällysverkko 1 kpl").visible = true
                this.scene.getObjectByName("Kalapesän päällysverkko 1 kpl").visible = true
                //console.log("Verkko on")
                //controls.maxPolarAngle = Math.PI * 0.495;
            }
            else {
                this.scene.getObjectByName("Etupesän päällysverkko 1 kpl (viiste)").visible = false
                this.scene.getObjectByName("Etupesän päällysverkko 1 kpl (suora osa)").visible = false
                this.scene.getObjectByName("Välipesän päällysverkko 1 kpl").visible = false
                this.scene.getObjectByName("Kalapesän päällysverkko 1 kpl").visible = false
                //console.log("Verkko off")
                //controls.maxPolarAngle = 100;
            }
    },
    setView(v) {
      this.m.view = v;
      var l = this.ep.l + this.vp.l + this.kp.l;
      var h = this.ep.h;

      if (v.name == "Etuviisto") {
        v.x = -l;
        v.y = 3 * h;
        v.z = l / 2;
      }
      if (v.name == "Takaviisto") {
        v.x = l / 2;
        v.y = 3 * h + 10;
        v.z = l / 2;
      }
      if (v.name == "Sivu") {
        v.x = -l / 2;
        v.y = h / 2;
        v.z = l;
      }
      if (v.name == "Oikea") {
        v.x = -l / 2;
        v.y = h / 2;
        v.z = -l;
      }
      if (v.name == "Taka") {
        v.x = l;
        v.y = 3 * h;
        v.z = 1;
      }
      if (v.name == "Ylä") {
        v.x = 0;
        v.y = 1.5 * l;
        v.z = 0;
      }

      this.camera.position.set(v.x, v.y, v.z);
    },
    getConfig(group) {
      return this.m.dim.filter(function(d) {
        return d.group === group;
      });
    },
    updateDraw() {
      var pi = Math.PI;
      this.nets = [];
      this.scene = new Three.Scene();
      this.scene.background = new Three.Color(0xffffff);
      var alight = new Three.AmbientLight(0x404040, 1.4); // soft white light
      this.scene.add(alight);

      // Materials
      const textureLoader = new Three.TextureLoader();
      //var texture = textureLoader.load("verkko.png");
      //texture.wrapS = texture.wrapT = Three.RepeatWrapping;
      //texture.repeat.set(1, 1);
      //var material = {};
      var materialep = {};
      var materialvp = {};
      var materialkp = {};

      //if (this.m.material) {
      //  material = this.m.material;
        //var rx = l / material.x
      //  texture.repeat.set(1 / material.x, 1 / material.y);
      //}

      var textureep = textureLoader.load("verkko.png");
      textureep.wrapS = textureep.wrapT = Three.RepeatWrapping;
      textureep.repeat.set(1 / (this.m.dim[13].value/1000) , 1 / (this.m.dim[13].value/1000) );
      materialep.texture = textureep;
      
      var texturevp = textureLoader.load("verkko.png");
      texturevp.wrapS = texturevp.wrapT = Three.RepeatWrapping;
      texturevp.repeat.set(1 / (this.m.dim[14].value/1000) , 1 / (this.m.dim[14].value/1000) );
      materialvp.texture = texturevp;

      var texturekp = textureLoader.load("verkko.png");
      texturekp.wrapS = texturekp.wrapT = Three.RepeatWrapping;
      texturekp.repeat.set(1 / (this.m.dim[15].value/1000) , 1 / (this.m.dim[15].value/1000) );
      materialkp.texture = texturekp




      //mat = new Three.MeshBasicMaterial( { color: 0x00ff00 } );

      // Etupesä
      var kulma_rad = 26.565051177078 * (pi / 180);
      var kulmavp_rad = Math.atan(1/8)// * (pi / 180); // 1 suhde 8
      var kulmavpnielu_rad = Math.atan(1/3)// * (pi / 180); // 1 suhde 8
      var kulmakpnielu_rad = Math.atan(1/3)// * (pi / 180); // 1 suhde 8

      var eppit =
        (this.m.dim[2].value / 2 - this.m.dim[7].value / 2) /
        Math.tan(kulma_rad);
      eppit = _.round(eppit, 2);

      //eppit = _.round(eppit,3)
      this.ep.l = eppit;
      var ep = {
        h: this.m.dim[0].value,
        l: eppit,
        w: this.m.dim[2].value,
        l2: 0,
        l2angle: 0,
        l3: this.m.dim[4].value,
        l4: 0,
        l5: 0,
        l6: 0,
        nielu: this.m.dim[3].value,
        potku: 0
      };

      // Välipesä
      var vpit =
        (this.m.dim[7].value / 2 - this.m.dim[9].value / 2) /
        Math.tan(kulmavp_rad);
      vpit = _.round(vpit, 2);

      var vp = {
        h: this.m.dim[5].value,
        l: vpit,
        w: this.m.dim[7].value,
        nw: this.m.dim[8].value,
        l2: 0,
        l2angle: 0
      };

      // Kalapesä
      //var vpit =
      //  (this.m.dim[9].value / 2 - this.m.dim[9].value / 2) /
      //  Math.tan(kulma_rad);
      //kpit = _.round(eppit, 3);

      var kp = {
        h: this.m.dim[9].value,
        l: this.m.dim[10].value,
        w: this.m.dim[9].value,
        w2: this.m.dim[12].value,
        h2: this.m.dim[12].value,
        nw: this.m.dim[11].value,
        nw2: this.m.dim[11].value,
        nl2: 0,

        l2: 0,
        l2angle: 0
      };

      // Lasketaan puuttuvat mitat ja kulmat
      ep.l2 = _.round(Math.hypot((ep.l), ep.w / 2 - vp.w / 2), 2);
      ep.l2angle = Math.acos(ep.l / ep.l2);
      ep.l2angleD = _.round(ep.l2angle * (180 / pi), 2);

      vp.l2 = _.round(Math.hypot(vp.l, vp.w / 2 - kp.w / 2), 2);
      vp.l2angle = Math.acos(vp.l / vp.l2);
      vp.l2angleD = _.round(vp.l2angle * (180 / pi), 2);

      // Etupesän sivuverkon viiste
      eppit = (ep.l - ep.l3 ) / Math.cos(kulma_rad);
      eppit = _.round(eppit, 2);
      ep.l4 = eppit

      // Etupesän pääliverkon viiste
      eppit = _.round(Math.hypot((ep.l - ep.l3 ),ep.h-vp.h), 3); 
      ep.l5 = eppit

      // välipesän nielu
      vpit = _.round( 
        (vp.w/2 - vp.nw / 2) /
        Math.tan(kulmavpnielu_rad), 3)
      
      var vpit2 = _.round( 
        (vp.h/2 - vp.nw / 2) /
        Math.tan(kulmavpnielu_rad), 3)
      
      
      if( vpit2 > vpit ) { 
        //vpit = vpit2
        }


      vp.l3 = vpit //_.round(Math.hypot(vp.nl, vp.w / 2 - vp.nw / 2), 3);


      vp.l3angle = kulmavpnielu_rad //Math.acos(vp.nl / vp.l3);
      vp.l3angleD = _.round(vp.l3angle * (180 / pi), 2);

      kp.l2 = _.round(Math.hypot(kp.l, kp.w / 2 - kp.w2 / 2), 2);
      kp.l2angle = Math.acos(kp.l / kp.l2);
      kp.l2angleD = _.round(kp.l2angle * (180 / pi), 2);

      // kalapesän nielu
      vpit = _.round( 
        (kp.w/2 - kp.nw / 2) /
        Math.tan(kulmakpnielu_rad), 3)
     
      kp.nl2 = kp.w2;
      kp.l3 = vpit
      kp.l3angle = kulmakpnielu_rad 

      // kalapesän pääty
      kp.l4 = _.round(Math.hypot(kp.w2 / 2, kp.w2 / 2 ), 3);
      kp.l4angle = rad(45) //Math.acos(kp.nl2 / kp.l3);
      kp.l4angleD = _.round(kp.l4angle * (180 / pi), 2);

      // Päivitys
      this.ep = ep;
      this.vp = vp;
      this.kp = kp;

      // Etupesä
      var net = {
        name: "Etupesän sivuverkot 2 kpl (taitetaan etupesän potkuksi ja nieluksi)",
        material: materialep,
        coords: [0, 0, ep.l2, 0, ep.l2, ep.h, ep.l4, ep.h, 0, vp.h, 0, 0]
};

      var d = vp.w / 2;
      this.createNet(net, { x: 0, y: 0, z: d }, { x: 0, y: -ep.l2angle, z: 0 });
      this.createNet(net, { x: 0, y: 0, z: -d }, { x: 0, y: ep.l2angle, z: 0 });


      // Sivuverkon pääty ja nielu taitos 
      var pit = ep.w / 2 - ep.l3 - ep.nielu / 2;
      ep.potku = _.round(pit, 2);

      var net2 = {
        name: "Etupesän nieluverkko 2 kpl",
        info: ep,
        c: 2,
        material: materialep,
        coords: [0, 0, pit, 0, pit, ep.h, 0, ep.h, 0, 0]
      };
      //this.nets.push(net2);
      this.createNet(
        net2,
        { x: ep.l, y: 0, z: ep.w / 2 },
        { x: 0, y: rad(90), z: 0 }
      );
      this.createNet(
        net2,
        { x: ep.l, y: 0, z: -ep.w / 2 },
        { x: 0, y: rad(-90), z: 0 }
      );
      // this.createNet(
      //   net2,
      //   { x: ep.l, y: 0, z: ep.w / 2 - ep.w / 4 },
      //   { x: 0, y: rad(90 + 45), z: 0 }
      // );

      var pitv = Math.sqrt(ep.l3 * ep.l3 + ep.l3 * ep.l3);
      ep.l6 = _.round(pitv,2)

      net2 = {
        name: "Etupesän viisto nieluverkko 2 kpl",
        info: ep,
        c: 2,
        material: materialep,
        coords: [0, 0, pitv, 0, pitv, ep.h, 0, ep.h, 0, 0]
      };
      this.createNet(
        net2,
        { x: ep.l - ep.l3, y: 0, z: ep.nielu / 2 },
        { x: 0, y: rad(-45), z: 0 }
      );
      //
      this.createNet(
        net2,
        { x: ep.l - ep.l3, y: 0, z: -ep.nielu / 2 },
        { x: 0, y: rad(45), z: 0 }
      );

      net.coords=[0, 0, ep.l2, 0, ep.l2, ep.h, ep.l2,0, ep.l2+pit, 0, ep.l2+pit, ep.h, ep.l2+pit,0, ep.l2+pit+pitv,0,ep.l2+pit+pitv,ep.h, ep.l4, ep.h, 0, vp.h,0,0]

      this.nets.push(net);
      

      // Aitaverkko
      net = {
        name: "Etupesän aitaverkko 1 kpl",
        material: materialep,
        coords: [0, 0, 3 * ep.l3, 0, 3 * ep.l3, ep.h, 0, ep.h, 0, 0]
      };
      //this.nets.push(net);

      this.createNet(
        net,
        { x: ep.l - ep.l3, y: 0, z: 0 },
        { x: 0, y: 0, z: 0 }
      );

      // Etupesän pääliverkot
      var al = 0.7;
      var aX = 0.4;
      var aY = 0.8;

      d=Math.tan(kulma_rad)*(ep.l-ep.l3)+vp.w/2

      net = {
        name: "Etupesän päällysverkko 1 kpl (viiste)",
        material: materialep,
        coords: [ 0, -vp.w / 2, ep.l5 , -d, ep.l5, d,0,vp.w/2,0,-vp.w/2  ]
      };
      var ang = Math.atan((ep.h - vp.h) / (ep.l-ep.l3));
      this.createNet(
        net,
        { x: 0, y: vp.h, z: 0 },
        { x: rad(90), y: ang, z: 0 }
      );

      // 2d kuvaa varten
      net.name =  "Etupesän päällysverkko 1 kpl (viiste + suoraosa)"
      net.coords=[ 0, -vp.w / 2, ep.l5, -d, ep.l5, d,  ep.l5, -d, ep.l5+ep.l3, -ep.w / 2 ,ep.l5+ep.l3, ep.w / 2, ep.l5, d,0,vp.w/2,0,-vp.w/2  ]
      this.nets.push(net);


      // suora osa 3d kuvaan
    
      net = {
        name: "Etupesän päällysverkko 1 kpl (suora osa)",
        material: materialep,
        coords: [ ep.l-ep.l3, -d, ep.l, -ep.w / 2, ep.l, ep.w / 2,ep.l-ep.l3, d,ep.l-ep.l3, -d ],
        holes: [
          [
            ep.l - aX,
            ep.w / 2 - aY - al,
            ep.l - aX,
            ep.w / 2 - aY,
            ep.l - aX - al,
            ep.w / 2 - aY,
            ep.l - aX - al,
            ep.w / 2 - aY - al,
            ep.l - aX,
            ep.w / 2 - aY - al
          ],
          [
            ep.l - aX,
            -ep.w / 2 + aY + al,
            ep.l - aX,
            -ep.w / 2 + aY,
            ep.l - aX - al,
            -ep.w / 2 + aY,
            ep.l - aX - al,
            -ep.w / 2 + aY + al,
            ep.l - aX,
            -ep.w / 2 + aY + al
          ]
        ]
      };

      this.createNet(
        net,
        { x: 0, y: ep.h, z: 0 },
        { x: rad(90), y: 0, z: 0 }
      );

      // Etupesän pohjaverkko
      net = {
        name: "Etupesän pohjaverkko 1 kpl",
        material: materialep,
        coords: [
          0,
          -vp.w / 2,
          ep.l,
          -ep.w / 2,
          ep.l,
          ep.w / 2,
          0,
          vp.w / 2,
          0,
          -vp.w / 2
        ]
      };
      this.nets.push(net);
      this.createNet(net, { x: 0, y: 0, z: 0 }, { x: rad(90), y: 0, z: 0 });


      // Välipesä
      net = {
        name: "Välipesän sivuverkot 2 kpl",
        material: materialvp,
        coords: [0, 0, vp.l2, 0, vp.l2, vp.h, 0, kp.h, 0, 0]
      };
      this.nets.push(net);
      d = kp.w / 2;
      this.createNet(
        net,
        { x: -vp.l2, y: 0, z: d },
        { x: 0, y: -vp.l2angle, z: 0 }
      );
      this.createNet(
        net,
        { x: -vp.l2, y: 0, z: -d },
        { x: 0, y: vp.l2angle, z: 0 }
      );

      // Välipesän pääliverkot
      net = {
        name: "Välipesän pohjaverkko 1 kpl",
        material: materialvp,
        coords: [
          0,
          -kp.w / 2,
          vp.l,
          -vp.w / 2,
          vp.l,
          vp.w / 2,
          0,
          kp.w / 2,
          0,
          -kp.w / 2
        ]
      };
      this.nets.push(net);
      this.createNet(net, { x: -vp.l, y: 0, z: 0 }, { x: rad(90), y: 0, z: 0 });

      net = {
        name: "Välipesän päällysverkko 1 kpl",
        material: materialvp,
        coords: [
          0,
          -kp.w / 2,
          vp.l,
          -vp.w / 2,
          vp.l,
          vp.w / 2,
          0,
          kp.w / 2,
          0,
          -kp.w / 2
        ]
      };
      this.nets.push(net);

      ang = Math.asin((vp.h - kp.h) / vp.l2);
      this.createNet(
        net,
        { x: -vp.l, y: kp.h, z: 0 },
        { x: rad(90), y: ang, z: 0 }
      );

      // Välipesän nielu
      net = {
        name: "Välipesän nielun sivuverkot 2 kpl",
        material: materialvp,
        coords: [0, 0, vp.l3, 0, vp.l3, vp.h, 0, vp.nw, 0, 0]
      };
      this.nets.push(net);
      d = vp.nw / 2;
      this.createNet(
        net,
        { x: -vp.l3, y: 0, z: d },
        { x: 0, y: -vp.l3angle, z: 0 }
      );
      this.createNet(
        net,
        { x: -vp.l3, y: 0, z: -d },
        { x: 0, y: vp.l3angle, z: 0 }
      );
      
      d= _.round(Math.hypot(vp.l3, vp.h - vp.nw ), 2);

      net = {
        name: "Välipesän nielun päällysverkko 1 kpl",
        material: materialvp,
        coords: [
          0,
          -vp.nw / 2,
          d,
          -vp.w / 2,
          d,
          vp.w / 2,
          0,
          vp.nw / 2,
          0,
          -vp.nw / 2
        ]
      };
      this.nets.push(net);

      ang = Math.asin((vp.h - vp.nw) / d);
      this.createNet(
        net,
        { x: -vp.l3, y: vp.nw, z: 0 },
        { x: rad(90), y: ang, z: 0 }
      );

      // Kalapesä
      net = {
        name: "Kalapesän sivuverkot 2 kpl",
        material: materialkp,
        coords: [0, 0, kp.l2, 0, kp.l2, kp.w, 0, kp.w2, 0, 0]
      };
      this.nets.push(net);
      d = kp.w2 / 2;
      this.createNet(
        net,
        { x: -vp.l2 - kp.l2, y: 0, z: d },
        { x: 0, y: -kp.l2angle, z: 0 }
      );
      this.createNet(
        net,
        { x: -vp.l2 - kp.l2, y: 0, z: -d },
        { x: 0, y: kp.l2angle, z: 0 }
      );

      // Kalapesän pääliverkot
      net = {
        name: "Kalapesän pohjaverkko 1 kpl",
        material: materialkp,
        coords: [
          0,
          -kp.w2 / 2,
          kp.l,
          -kp.w / 2,
          kp.l,
          kp.w / 2,
          0,
          kp.w2 / 2,
          0,
          -kp.w2 / 2
        ]
      };
      this.nets.push(net);
      this.createNet(
        net,
        { x: -vp.l - kp.l, y: 0, z: 0 },
        { x: rad(90), y: 0, z: 0 }
      );

      net = {
        name: "Kalapesän päällysverkko 1 kpl",
        material: materialkp,
        coords: [
          0,
          -kp.w2 / 2,
          kp.l,
          -kp.w / 2,
          kp.l,
          kp.w / 2,
          0,
          kp.w2 / 2,
          0,
          -kp.w2 / 2
        ]
      };
      this.nets.push(net);
      ang = Math.asin((kp.h - kp.h2) / kp.l2);
      this.createNet(
        net,
        { x: -vp.l - kp.l, y: kp.h2, z: 0 },
        { x: rad(90), y: ang, z: 0 }
      );

      // Kalapesän nielu

      net = {
        name: "Kalapesän nielun verkot 4 kpl",
        material: materialkp,
        coords: [0,-kp.nw / 2,kp.l3,-kp.w / 2,kp.l3,kp.w / 2,0,kp.nw / 2,0,-kp.nw / 2]
      };
      this.nets.push(net);

      ang = kulmakpnielu_rad
      this.createNet(
        net,
        { x: -vp.l - kp.l3, y: (0.5*kp.h - 0.5*kp.nw), z: 0 },
        { x: rad(90), y: -ang, z: 0 }
      );

      this.createNet(
        net,
        { x: -vp.l - kp.l3, y: (0.5*kp.h + 0.5*kp.nw), z: 0 },
        { x: rad(90), y: ang, z: 0 }
      );

      this.createNet(
        net,
        { x: -vp.l - kp.l3, y:0.5*kp.h , z: kp.nw / 2 },
        { x: rad(0), y: -ang, z: 0 }
      );
      this.createNet(
        net,
        { x: -vp.l - kp.l3, y:0.5*kp.h , z: -kp.nw / 2 },
        { x: rad(0), y: ang, z: 0 }
      );
    
      // Kalapesän päätyverkot
      

      net = {
        name: "Kalapesän pääty verkot 4 kpl",
        material: materialkp,
        coords: [ 0, 0, kp.nl2, -kp.w2 / 2, kp.nl2, kp.w2 / 2, 0,0  ]
      };
      this.nets.push(net);

      ang = rad(30)//Math.asin((kp.w2 / 2) / kp.l4);
      d=(kp.w2/2) / Math.tan(ang)

      this.createNet(
        net,
        { x: -vp.l -kp.l -d, y: kp.w2 / 2, z: 0 },
        { x: rad(90), y: -ang, z: 0 }
      );
      this.createNet(
        net,
        { x: -vp.l -kp.l -d,  y: 0.5 * kp.w2, z: 0 },
        { x: rad(90), y: ang, z: 0 }
      );
      this.createNet(
        net,
        {
          x: -vp.l -kp.l -d,
          y: 0.5 * kp.w2,
          z: 0
        },
        { x: rad(0), y: ang, z: 0 }
      );
      this.createNet(
        net,
        {
          x: -vp.l -kp.l -d,
          y: 0.5 * kp.h2 + (0 * kp.nw2) / 2,
          z: 0
        },
        { x: rad(0), y: -ang, z: 0 }
      );

      // Koenta sukka
      var c = [
        { x: -vp.l - kp.nl2/2 - kp.l, y: kp.h2/4, z: 0 },
        { x: -vp.l - kp.nl2/4 - kp.l, y: 0, z: 0 },
        { x: -vp.l  - kp.nl2/4 - kp.l, y: 0, z: 0.5 },
        { x: -vp.l , y: 0, z: 1.5 },
        { x: -vp.l /2  , y: 0, z: 2.5 },


      ];
      this.createTube(c, materialkp);
      if(this.update == 1) this.setView({name: "Etuviisto"})
      this.update += 20
    },
    opt(val) {
      var d = [];
      var step = val.step;
      for (var i = val.min; i < val.max; i = i + step) d.push(_.round(i, 2));
      return d;
    },
    calcDraw() {
      //var m = 5;
      //var g = this.g;

      // Lasketaan pitkä sivu pythagoran avulla
      //g.d4 = Math.pow(Math.pow(g.d1 - g.d3, 2) + Math.pow(g.d2, 2), 0.5);
      this.create3d();
      this.animate();
    },
    createTube(c, material) {
      var path = [];
      for (var i in c) {
        path.push(new Three.Vector3(c[i].x, c[i].y, c[i].z));
      }
      var pathBase = new Three.CatmullRomCurve3(path);

      var geometry = new Three.TubeGeometry(pathBase, 20, 0.1, 20, false);

      var mat = new Three.MeshPhongMaterial({
        map: material.texture,
        opacity: 0.8,
        transparent: true,
        side: Three.DoubleSide
      });

      //var material = new Three.MeshBasicMaterial({ color: 0x00ff00 });
      var mesh = new Three.Mesh(geometry, mat);
      this.scene.add(mesh);
    },
    createNet(net, place, rotate) {
      if (net.material.texture)
        var mat = new Three.MeshPhongMaterial({
          map: net.material.texture,
          opacity: 0.8,
          transparent: true,
          side: Three.DoubleSide
        });
      else
        mat = new Three.MeshPhongMaterial({
          color: 0x008080,
          opacity: 0.5,
          transparent: true,
          side: Three.DoubleSide
        });

      var shape = new Three.Shape();
      shape.moveTo(0, 0);

      for (var i = 0; i < net.coords.length; i = i + 2) {
        var x = net.coords[i];
        var y = net.coords[i + 1];
        shape.lineTo(x, y);
      }

      // Makes holes
      if (net.holes) {
        var holes = new Three.Path();
        //holes.moveTo(0, 0);
        for (var j = 0; j < net.holes.length; j++) {
          for (i = 0; i < net.holes[j].length; i = i + 2) {
            x = net.holes[j][i];
            y = net.holes[j][i + 1];
            if (i == 0) holes.moveTo(x, y);
            else holes.lineTo(x, y);
          }
          shape.holes.push(holes);
          holes = new Three.Path();
        }
      }

      var geometry = new Three.ShapeGeometry(shape);
      var mesh = new Three.Mesh(geometry, mat);
      if (place) mesh.position.set(place.x, place.y, place.z);

      if (rotate) {
        mesh.rotateX(rotate.x);
        mesh.rotateY(rotate.y);
        mesh.rotateZ(rotate.z);
      }
    
      var obj = new Three.Object3D();
      obj.name = net.name
      obj.add(mesh)

      this.scene.add(obj);
    },

    createNet3D(net, place, rotate) {
      if (net.material.texture)
        var mat = new Three.MeshPhongMaterial({
          map: net.material.texture,
          opacity: 0.8,
          transparent: true,
          side: Three.DoubleSide
        });
      else
        mat = new Three.MeshPhongMaterial({
          color: 0x008080,
          opacity: 0.5,
          transparent: true,
          side: Three.DoubleSide
        });

      var shape = new Three.Shape();
      shape.moveTo(0, 0);

      for (var i = 0; i < net.coords.length; i = i + 3) {
        var x = net.coords[i];
        var y = net.coords[i + 1];
        var z = net.coords[i + 2];
        shape.lineTo(x, y, z);
      }
      var geometry = new Three.ShapeGeometry(shape);
      var mesh = new Three.Mesh(geometry, mat);
      if (place) mesh.position.set(place.x, place.y, place.z);

      if (rotate) {
        mesh.rotateX(rotate.x);
        mesh.rotateY(rotate.y);
        mesh.rotateZ(rotate.z);
      }
      this.scene.add(mesh);
    },

    create3d() {
      //const scene = new THREE.Scene();
      let container = document.getElementById("model3d");
      var clientWidth = 1200;
      var clientHeight = 800;

      this.camera = new Three.PerspectiveCamera(
        50,
        clientWidth / clientHeight,
        1,
        1000
      );
      this.camera.position.z = 1;

      this.scene = new Three.Scene();
      this.scene.background = new Three.Color(0xffffff);
      var alight = new Three.AmbientLight(0x404040, 1.4); // soft white light
      this.scene.add(alight);

      this.renderer = new Three.WebGLRenderer({ antialias: true });
      this.renderer.setSize(clientWidth, clientHeight);
      container.appendChild(this.renderer.domElement);

      this.controls = new OrbitControls(this.camera, this.renderer.domElement);

      //controls.update() must be called after any manual changes to the camera's transform
      //this.camera.position.set(40, 40, 40);
      //this.camera.position.set(-10, 10, 10);
      
      this.controls.update();
    },
    animate() {
            var rotSpeed = 0.001


            //if (this.s.ilta == 1) {
            //    this.light.position.set(1000, 200, 5000)
//
  //          }
      //      else {
    //            this.light.position.set(5000, 5000, 5000)
        //    }

            if (this.s.rotate) {
                var x = this.camera.position.x,
                    z = this.camera.position.z;
                this.camera.position.x = x * Math.cos(rotSpeed) + z * Math.sin(rotSpeed);
                this.camera.position.z = z * Math.cos(rotSpeed) - x * Math.sin(rotSpeed);
                this.camera.lookAt(this.scene.position);
            }
            //render();

      requestAnimationFrame(this.animate);
      this.controls.update();
      this.renderer.render(this.scene, this.camera);
      this.controls.update();
    }
  }
};
</script>
